export default __webpack_public_path__ + "static/media/Illustration.07936670.svg";